import React from 'react';
import { translate, Interpolate } from 'react-i18next';

const ErrorsSection = (props) => (
  <section className="method row" id="errors">
    <div className="method__text col-lg-6">
      <h2>{props.t('title')}</h2>
      <hr />
      <Interpolate i18nKey='description' useDangerouslySetInnerHTML={true} />
    </div>
    <div className="method__code col-lg-6">
      <h5>{props.t('titles.status')}</h5>
      <div className="table-responsive">
        <table className="table table-dark table-striped">
          <tbody>
            <tr>
              <th>200 – OK</th>
              <td>{props.t('statusCodes.200')}</td>
            </tr>
            <tr>
              <th>401 – Unauthorized</th>
              <td>{props.t('statusCodes.401')}</td>
            </tr>
            <tr>
              <th>403 – Forbidden</th>
              <td>{props.t('statusCodes.403')}</td>
            </tr>
            <tr>
              <th>500</th>
              <td>{props.t('statusCodes.500')}</td>
            </tr>                  
          </tbody>
        </table>
      </div>

      <h5>{props.t('titles.messages')}</h5>
      <div className="table-responsive">
        <table className="table table-dark table-striped">
          <tbody>
            <tr>
              <th>401</th>
              <td><code>{props.t('errorMessages.401')}</code></td>
            </tr>
            <tr>
            <th>403</th>
              <td><code>{props.t('errorMessages.403')}</code></td>
            </tr>
            <tr>
            <th>500</th>
              <td><code>{props.t('errorMessages.500')}</code></td>
            </tr>
            <tr>
            <th>500</th>
              <td><code>{props.t('errorMessages.500-alt')}</code></td>
            </tr>                  
          </tbody>
        </table>
      </div>

    </div>
  </section>
);

export default translate('ErrorsSection')(ErrorsSection);



// WEBPACK FOOTER //
// ./src/components/sections/ErrorsSection.jsx